import { SR_API_ACTION_RENTLINX_LEAD_GET_BY_ID } from 'api/actionTypes';

export default async function getByPhone({ state, apiClient }, { rentlinxLeadId }) {
  const rentlinxLead = await apiClient.postWithState({
    action: SR_API_ACTION_RENTLINX_LEAD_GET_BY_ID,
    state: state,
    payload: {
      rentlinxLeadId,
    },
  });

  if (rentlinxLead) {
    state.set(['rentlinxLead', 'byId', rentlinxLeadId], rentlinxLead);
  }

  return rentlinxLead;
}
